import Vue from 'vue';

export default function showError(err: any) {
  if (typeof err === 'string') {
    Vue.$toast.error(err);
  } else {
    Vue.$toast.error('Erro inesperado');
  }
}
